/**
 * TravelTainmentRatingsReviews component.
 */
define([
        'jQuery',
        'library/fcse-compatibility/object',
        'library/fcse-component/optionsMixin'
    ],
    function ($, Object, OptionsMixin) {

        let TravelTainmentRatingsReviews = function (element, requestHandler) {
            // Set default options
            let defaultOptions = {
                loadingClass: 'is-loading',
                ratingShowMoreBtnSelector: '[data-fcse-role="rating-show-more"]',
                getHotelRatingRoute: 'allt_frontend.get_hotel_rating'
            };

            // Store element
            this.element = $(element);

            // Save local variables
            this.requestHandler = requestHandler;
            this._activeRatingId = false;

            this.addOptions(defaultOptions);

            this._init();
            this._initLoadingEvents();
        };

        TravelTainmentRatingsReviews.prototype = $.extend(Object.create(OptionsMixin), {
            /**
             * Initialize TravelTainmentRatingsReviews
             *
             * @private
             */
            _init: function () {
                this.element.on(
                    'click', this.option('ratingShowMoreBtnSelector'),
                    $.proxy(this._onRatingShowMoreBtnClick, this)
                );
            },

            /**
             * Click handler for show more link
             * @param event
             * @private
             */
            _onRatingShowMoreBtnClick: function (event) {
                let ratingId = $(event.currentTarget).data('rating-id');
                const fullReview = this.element.find('[data-fcse-role="full-review-' + ratingId + '"]');

                if (fullReview && fullReview.html().length) {
                    this._showUserReviews(ratingId);
                } else {
                    let iffCode = this.element.data('iffcode');

                    this._activeRatingId = ratingId;
                    this.element
                        .find('[data-fcse-role="short-review-' + ratingId + '"]')
                        .parent()
                        .addClass(this.option('loadingClass'));

                    // Load content
                    this._loadContent({
                        ratingId: ratingId,
                        iffCode: iffCode
                    });
                }
            },

            _showUserReviews: function (ratingId) {
                let shortReview = this.element.find('[data-fcse-role="short-review-' + ratingId + '"]');
                let fullReview = this.element.find('[data-fcse-role="full-review-' + ratingId + '"]');
                let closeBtn = fullReview.find('[data-fcse-role="rating-show-less"]');

                closeBtn.off('click').one('click', function (e) {
                    fullReview.hide();
                    shortReview.show();
                    $('html,body').animate({scrollTop: shortReview.offset().top}, 'slow');
                });

                shortReview.hide();
                fullReview.show();
                // Scrolling to review
                $('html,body').animate({scrollTop: fullReview.offset().top}, 'slow');
            },

            /**
             * Initialize Loading Events
             *
             * @private
             */
            _initLoadingEvents: function () {
                this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
            },

            /**
             * Handler for content loading success
             *
             * @param event
             * @param data
             * @protected
             */
            _onLoadContentSuccess: function (event, data) {
                // Check if ajax response is from getHotelRatingRoute
                if (data.route !== this.option('getHotelRatingRoute')) {
                    return;
                }

                if (typeof data.routeParams.ratingId === 'undefined') {
                    return;
                }

                if (data.routeParams.ratingId !== this._activeRatingId) {
                    return;
                }

                // Unset loading state
                this.element
                    .find('[data-fcse-role="short-review-' + data.routeParams.ratingId + '"]')
                    .parent()
                    .removeClass(this.option('loadingClass'));

                // Replace HTML content
                this.element.find('[data-fcse-role="full-review-' + data.routeParams.ratingId + '"]').html(event.html);
                this._showUserReviews(data.routeParams.ratingId);
            },

            /**
             * @private
             */
            _loadContent: function (params) {
                // Send request
                this.requestHandler.cancel(this.option('getHotelRatingRoute'));
                this.requestHandler.send(this.option('getHotelRatingRoute'), {}, params);
            }
        });

        return TravelTainmentRatingsReviews;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/traveltainmentratings/travelTainmentRatingsReviews.js